// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3604":"acad4d49","5202":"daf2524e","5641":"3bd82c27"}[chunkId] + ".chunk.css";
};